import $ from 'jquery';

$('.site-header__more').on('click', function (e) {
    e.preventDefault();
    var offset = $(this).parents('.site-header').outerHeight() + $(this).parents('.site-header').offset().top;
    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    });
})